//@ts-ignore
import { actions as LKModalActions } from 'shared/LKModal'
import { MODAL_NAME } from './constants'

export const open = (row) => LKModalActions.open({ name: MODAL_NAME, row })
